import React from 'react'
import { useEffect, useRef, useState } from 'react'
import { Table, Space, Pagination, Input, Col, Row, Image, Modal, Checkbox, Button, Popover } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   DATE_TIME_FORMAT_CLIENT_short,
   DATE_TIME_FORMAT_CLIENT_short2,
   PAGE_SIZE,
   ROLE,
   STATUS_ACTIVITY,
   STATUS_JOB,
   STATUS_JOB_ASSIGNABLE_BY_ADMIN,
   STATUS_JOB_CANCELLABLE_BY_ADMIN,
   STATUS_JOB_FINISHABLE_BY_ADMIN,
   getPage,
   getStatusText
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import AssignJob from './AssignJob'
import BulkAssignJob from './BulkAssignJob'
import ApproveJobModal from './ApproveJobModal'
import JobLinkCell from './JobLinkCell'
import JobNoteCell from './JobNoteCell'
import JobSuggestionCell from './JobSuggestionCell'
import JobHashtags from 'src/common/components/hashtag/JobHashtags'
// import Detail from './Detail'
import useWindowDimensions from '../../common/useWindowDimensions'
import Filter from 'src/common/components/Filter/Filter'
import ActiveFilterSummary from 'src/common/components/Filter/ActiveFilterSummary'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { DATE_TIME_FORMAT_CLIENT } from '../../helpers/constants'
import { DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { EditJobDetailModal } from '../job-detail/EditJobDetailCreator'
import { formatCurrency, showMessageSuccess, showMessageError, getImageUrl } from 'src/helpers/functions'
import useModal from 'src/helpers/modal/useModal'
import DetailCreator from '../creator-management/Detail'
import DetailDesigner from '../designer-management/Detail'
import theme from 'src/helpers/theme'

// Nut "Xoa" tren bang da tat theo yeu cau van hanh. Chi an nut, con handleDeleteJob
// va API /job/delete giu nguyen — bat lai chi can doi co nay thanh true.
const SHOW_DELETE_JOB_BUTTON: boolean = false

// Server chi cho xoa viec chua co designer nhan; viec da hoan thanh thi khong xoa
const isDeletableJob = (job: any) => !job?.designerId && job?.status !== STATUS_JOB.FINISH

const JobManagement = observer((props: any) => {
   const { t } = useTranslation()
   const JobsStore = useStore('JobsStore')
   const JobDetailStore = useStore('JobDetailStore')
   // const CommonConfigStore = useStore('CommonConfigStore')
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   // const { designTypesList, productTypesList } = CommonConfigStore
   const [visible, setVisible] = useState(false)
   const [textSearch, set_textSearch] = useState('')
   const [searchInput, setSearchInput] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [isLoading, setIsLoading] = useState(false)
   const { height } = useWindowDimensions()
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [visibleFilter, setVisibleFilter] = useState(false)
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [status, setStatus] = useState(POSITION_INFO.ALL.id)
   // const history = useHistory()
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const [statusObj, setStatusObj] = useState<any>({
      pending: [STATUS_JOB.PENDING],
      new: [STATUS_ACTIVITY.NEW],
      doing: [STATUS_ACTIVITY.DOING],
      review: '',
      finish: '',
      reject: [STATUS_ACTIVITY.REJECT]
   })
   const { jobTotal } = JobsStore
   const { rows, offset, count } = JobsStore.jobs
   const [isOpenEditJobDetail, setIsOpenEditJobDetail] = useState(false)
   const [selectedItem, setSelectedItem] = useState<any>([])

   // Viec dang cho duyet trong popup "Duyet viec": mot viec khi bam tren dong,
   // nhieu viec khi bam nut duyet hang loat.
   const [approveTarget, setApproveTarget] = useState<any>(null)

   const [visibleAssign, setVisibleAssign] = useState<any>(false)
   const [itemUser, setItemUser] = useState<any>(null)
   const [itemDesigner, setItemDesigner] = useState(null)
   const [itemCreator, setItemCreator] = useState(null)
   const [visibleUserDetailCreator, setVisibleUserDetailCreator] = useState<any>(false)
   const [visibleUserDetailDesigner, setVisibleUserDetailDesigner] = useState<any>(false)
   const { confirm } = useModal()
   // Chon nhieu dong de hoan thanh hoac huy hang loat
   const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
   const [selectedRows, setSelectedRows] = useState<any[]>([])
   const [isBulkProcessing, setIsBulkProcessing] = useState(false)
   const [isExporting, setIsExporting] = useState(false)

   useEffect(() => {
      const statusResult = [
         ...statusObj.pending,
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
      // JobsStore.getJobTotal(statusResult)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch])

   const onSubmitFilter = (value: any) => {
      const statusResult = [
         ...statusObj.pending,
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()
      // console.log('statusNow: ', statusObj, 'statusResult; ', statusResult)
      // setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      setFieldFilter({ ...fieldFilter, ...value, ...{ status: statusResult } })
      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...value, ...{ status: statusResult } })
   }

   const onResetFilter = () => {
      const page = 0
      setFieldFilter({})
      getListData(0, { ...{ text: trim(textSearch) } })
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage, PAGE_SIZE)
         const params = { offset, ...param }

         await JobsStore.getJobListAdmin(params)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      // console.log('currentPage;', currentPage, 'currentPage-1', currentPage - 1)
      const statusResult = [
         ...statusObj.pending,
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(currentPage - 1, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
   }

   // Export Excel dung bo loc + trang thai + tu khoa dang hien tren bang, lay het khong phan trang
   const handleExportExcel = async () => {
      const statusResult = [
         ...statusObj.pending,
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()
      setIsExporting(true)
      try {
         await JobsStore.exportJobs({ ...fieldFilter, text: trim(textSearch), status: statusResult })
      } finally {
         setIsExporting(false)
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   // Bam hashtag trong bang -> tim theo "#hashtag"
   const handleSearchHashtag = (name: string) => {
      setSearchInput(`#${name}`)
      set_textSearch(`#${name}`)
   }

   // Bam hashtag trong popup chi tiet -> dien "#hashtag" vao o tim kiem. Bo qua gia tri cu tu truoc khi mo trang
   const mountedAt = useRef(Date.now())
   useEffect(() => {
      const { name, at } = JobsStore.hashtagSearch
      if (!name || at < mountedAt.current) return
      setSearchInput(`#${name}`)
      set_textSearch(`#${name}`)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [JobsStore.hashtagSearch])

   const handleShowDetail = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setIsOpenEditJobDetail(true)
   }

   const handleAssignJob = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setVisibleAssign(true)
   }

   const handleCloseAssign = () => {
      setVisibleAssign(false)
   }
   const openEditJobModal = () => {
      setIsOpenEditJobDetail(true)
   }

   const closeEditJobModal = () => {
      setIsOpenEditJobDetail(false)
   }

   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = { ...statusObj }
      switch (key) {
         case STATUS_JOB.PENDING:
            if (e.target.checked) {
               statusNow.pending = [STATUS_JOB.PENDING]
            } else {
               statusNow.pending = []
            }
            break
         case STATUS_ACTIVITY.NEW:
            if (e.target.checked) {
               statusNow.new = [STATUS_ACTIVITY.NEW]
            } else {
               statusNow.new = []
            }
            break
         case STATUS_ACTIVITY.DOING:
            if (e.target.checked) {
               statusNow.doing = [STATUS_ACTIVITY.DOING]
            } else {
               statusNow.doing = []
            }
            break
         case STATUS_ACTIVITY.REVIEW:
            if (e.target.checked) {
               statusNow.review = [STATUS_ACTIVITY.REVIEW]
            } else {
               statusNow.review = []
            }
            break
         case STATUS_ACTIVITY.REJECT:
            if (e.target.checked) {
               statusNow.reject = [STATUS_ACTIVITY.REJECT]
            } else {
               statusNow.reject = []
            }
            break
         default:
            if (e.target.checked) {
               statusNow.finish = [STATUS_ACTIVITY.FINISH]
            } else {
               statusNow.finish = []
            }
            break
      }
      setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      const statusResult = [
         ...statusNow.pending,
         ...statusNow.new,
         ...statusNow.doing,
         ...statusNow.review,
         ...statusNow.reject,
         ...statusNow.finish
      ].toString()
      // console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
   }

   const handleDeleteJob = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonxoabanghi),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await JobsStore.deleteJob(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }
   const handlePriority = async (value: any, status: boolean, index: number) => {
      try {
         const res = await JobDetailStore.setJobPriority(value?.id, status)
         console.log('res', res)
         if (res) {
            // Sửa dữ liệu offline
            JobsStore.action_updateJobPriority(index, status)
         }
      } catch (error) {
         console.log(error)
      } finally {
      }

      // confirm({
      //    title: t(GLOBAL_CLIENT.setuutien),
      //    icon: <ExclamationCircleOutlined />,
      //    okText: t(GLOBAL_CLIENT.dongy),
      //    cancelText: t(GLOBAL_CLIENT.huy),
      //    onCancel() {},
      //    async onOk() {
      //       await JobDetailStore.setJobPriority(value?.id)
      //       if (size(trim(textSearch)) > 0) {
      //          getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) } })
      //       } else {
      //          getListData(0, { ...fieldFilter })
      //       }
      //    }
      // })
   }
   const handleEditDesigner = () => {
      // handle_getListData(page)
      hideDetailDesigner()
   }
   const handleEditCreator = () => {
      // handle_getListData(page)
      hideDetailCreator()
   }
   const hideDetailDesigner = () => {
      setVisibleUserDetailDesigner(false)
      setItemDesigner(null)
   }
   const hideDetailCreator = () => {
      setVisibleUserDetailCreator(false)
      setItemCreator(null)
   }

   const showDetailCreator = (item: any) => () => {
      setItemCreator(item)
      setTimeout(() => {
         setVisibleUserDetailCreator(true)
      }, 300)
   }
   const showDetailDesigner = (item: any) => () => {
      setItemDesigner(item)
      setTimeout(() => {
         setVisibleUserDetailDesigner(true)
      }, 300)
   }

   const handleCancelJob = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonhuyjob),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await JobsStore.cancelJob(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }

   const reloadList = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
   }

   /**
    * Duyet viec: viec chuyen sang "Mới" va hien len cho designer nhan.
    * Trong popup co the chon luon designer de giao ngay sau khi duyet.
    */
   const handleApproveJob = (value: any) => {
      setApproveTarget({
         items: [value],
         description: `Việc <b>${
            value?.name || ''
         }</b> sẽ chuyển sang trạng thái Mới và hiển thị cho designer nhận.`
      })
   }

   /**
    * Bam dong y trong popup duyet viec. Chon designer thi viec duoc duyet roi
    * giao ngay cho nguoi do, de trong thi chi duyet.
    */
   const handleConfirmApprove = async (designer: any) => {
      const target = approveTarget
      if (!target) return
      const designerId = designer?.id
      const designerName = designer?.name || designer?.email
      setApproveTarget(null)

      if (target.items.length === 1) {
         const ok = await JobsStore.approveJob(target.items[0]?.id, designerId)
         if (ok) {
            showMessageSuccess(designerId ? `Đã duyệt việc và giao cho ${designerName}` : 'Đã duyệt việc')
            reloadList()
         }
         return
      }

      await runBulkAction(
         target.items,
         (id) => JobsStore.approveJobSilent(id, designerId),
         designerId ? `Đã duyệt và giao cho ${designerName}` : 'Đã duyệt'
      )
   }

   /**
    * Hoan thanh viec truc tiep.
    * Viec da co designer thi designer duoc tra cong nhu khi creator phe duyet,
    * viec chua co designer thi chi xa tien hold cua creator.
    */
   const handleApproveAndFinishJob = (value: any) => {
      confirm({
         title: 'Hoàn thành',
         icon: <ExclamationCircleOutlined />,
         content: value?.designerId
            ? `Việc <b>${value?.name || ''}</b> sẽ chuyển sang <b>Hoàn thành</b>.<br/>Designer được trả công như khi creator phê duyệt. Thao tác này không thể hoàn tác.`
            : `Việc <b>${value?.name || ''}</b> sẽ chuyển thẳng sang <b>Hoàn thành</b>, không qua designer.<br/>Tiền đang giữ của creator sẽ được giải phóng và <b>không trả công cho designer nào</b>. Thao tác này không thể hoàn tác.`,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            const ok = await JobsStore.approveAndFinishJob(value?.id)
            if (ok) {
               showMessageSuccess('Đã hoàn thành việc')
               reloadList()
            }
         }
      })
   }

   const clearSelection = () => {
      setSelectedRowKeys([])
      setSelectedRows([])
   }

   const rowSelection = {
      selectedRowKeys,
      onChange: (keys: any[], rows: any[]) => {
         setSelectedRowKeys(keys)
         setSelectedRows(rows)
      },
      getCheckboxProps: (record: any) => ({
         // Chi cho chon nhung viec lam duoc it nhat mot thao tac hang loat
         disabled:
            !STATUS_JOB_FINISHABLE_BY_ADMIN.includes(record?.status) &&
            !STATUS_JOB_CANCELLABLE_BY_ADMIN.includes(record?.status) &&
            !STATUS_JOB_ASSIGNABLE_BY_ADMIN.includes(record?.status) &&
            !isDeletableJob(record)
      })
   }

   const approvableSelected = selectedRows.filter((item) => item?.status === STATUS_JOB.PENDING)
   const finishableSelected = selectedRows.filter((item) => STATUS_JOB_FINISHABLE_BY_ADMIN.includes(item?.status))
   const cancellableSelected = selectedRows.filter((item) => STATUS_JOB_CANCELLABLE_BY_ADMIN.includes(item?.status))
   const assignableSelected = selectedRows.filter((item) => STATUS_JOB_ASSIGNABLE_BY_ADMIN.includes(item?.status))
   const deletableSelected = selectedRows.filter(isDeletableJob)

   /**
    * Chay lan luot tung viec de khong ban qua nhieu request cung luc,
    * gom loi lai bao mot lan thay vi hien popup cho tung viec.
    */
   const runBulkAction = async (items: any[], action: (id: any) => Promise<any>, successText: string) => {
      setIsBulkProcessing(true)
      const failed: string[] = []
      let successCount = 0
      try {
         // eslint-disable-next-line no-restricted-syntax
         for (const item of items) {
            // eslint-disable-next-line no-await-in-loop
            const result = await action(item?.id)
            if (result?.ok) {
               successCount += 1
            } else {
               failed.push(`${item?.name || item?.id}: ${result?.message || 'thất bại'}`)
            }
         }
      } finally {
         setIsBulkProcessing(false)
      }

      if (successCount > 0) {
         showMessageSuccess(`${successText} ${successCount}/${items.length} việc`)
      }
      if (failed.length > 0) {
         // Chi liet ke toi da 5 dong cho de doc, con lai gom vao mot dong
         const lines = failed.slice(0, 5)
         const rest = failed.length - lines.length
         showMessageError(
            <div style={{ whiteSpace: 'pre-line' }}>
               {`${failed.length} việc không xử lý được:\n${lines.join('\n')}${
                  rest > 0 ? `\n... và ${rest} việc khác` : ''
               }`}
            </div>
         )
      }
      clearSelection()
      reloadList()
   }

   /**
    * Duyet nhieu viec cho duyet cung luc: cac viec chuyen sang Moi va hien len cho designer nhan.
    */
   const handleBulkApprove = () => {
      const items = approvableSelected
      if (items.length === 0) {
         showMessageError('Không có việc nào trong danh sách chọn đang chờ duyệt')
         return
      }
      const skipped = selectedRows.length - items.length
      setApproveTarget({
         items,
         title: 'Duyệt nhiều việc',
         okText: `Duyệt (${items.length})`,
         description: `${items.length} việc sẽ chuyển sang trạng thái <b>Mới</b> và hiển thị cho designer nhận.${
            skipped > 0 ? `<br/>${skipped} việc đang chọn không ở trạng thái Chờ duyệt và sẽ bị bỏ qua.` : ''
         }`
      })
   }

   /**
    * Hoan thanh nhieu viec cung luc. Viec da co designer se duoc tra cong nhu khi creator duyet.
    */
   const handleBulkFinish = () => {
      const items = finishableSelected
      if (items.length === 0) {
         showMessageError('Không có việc nào trong danh sách chọn có thể hoàn thành')
         return
      }
      const skipped = selectedRows.length - items.length
      const withDesigner = items.filter((item) => item?.designerId).length
      confirm({
         title: 'Hoàn thành nhiều việc',
         icon: <ExclamationCircleOutlined />,
         content: `${items.length} việc sẽ chuyển sang <b>Hoàn thành</b>.${
            withDesigner > 0 ? `<br/>${withDesigner} việc đã có designer sẽ được trả công như khi creator phê duyệt.` : ''
         }${skipped > 0 ? `<br/>${skipped} việc đang chọn không hoàn thành được và sẽ bị bỏ qua.` : ''}`,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await runBulkAction(items, (id) => JobsStore.finishJobSilent(id), 'Đã hoàn thành')
         }
      })
   }

   /**
    * Huy nhieu viec cung luc, cac viec quay ve trang thai Moi de tim designer khac.
    */
   const handleBulkCancel = () => {
      const items = cancellableSelected
      if (items.length === 0) {
         showMessageError('Không có việc nào trong danh sách chọn có thể huỷ')
         return
      }
      const skipped = selectedRows.length - items.length
      confirm({
         title: 'Huỷ nhiều việc',
         icon: <ExclamationCircleOutlined />,
         content: `${items.length} việc sẽ được huỷ và quay về trạng thái Mới để tìm designer khác.${
            skipped > 0 ? `<br/>${skipped} việc đang chọn không huỷ được và sẽ bị bỏ qua.` : ''
         }`,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await runBulkAction(items, (id) => JobsStore.cancelJobSilent(id), 'Đã huỷ')
         }
      })
   }

   /**
    * Xoa nhieu viec cung luc. Server chi cho xoa viec chua co designer nhan,
    * xoa xong hoan lai tien tao viec cho creator.
    */
   const handleBulkDelete = () => {
      const items = deletableSelected
      // Khong co viec nao xoa duoc van hien modal de bao ly do, thay vi bam khong thay gi
      if (items.length === 0) {
         confirm({
            title: 'Xoá nhiều việc',
            icon: <ExclamationCircleOutlined />,
            content: `Không có việc nào trong ${selectedRows.length} việc đang chọn xoá được.<br/>Chỉ xoá được việc <b>chưa có designer nhận</b> và chưa hoàn thành.`,
            okText: t(GLOBAL_CLIENT.dongy),
            cancelText: t(GLOBAL_CLIENT.huy),
            onCancel() {},
            onOk() {}
         })
         return
      }
      const skipped = selectedRows.length - items.length
      confirm({
         title: 'Xoá nhiều việc',
         icon: <ExclamationCircleOutlined />,
         content: `${items.length} việc sẽ bị <b>xoá</b> và hoàn lại tiền tạo việc cho creator. Không thể khôi phục.${
            skipped > 0 ? `<br/>${skipped} việc đang chọn đã có designer nên không xoá được và sẽ bị bỏ qua.` : ''
         }`,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await runBulkAction(items, (id) => JobsStore.deleteJobSilent(id), 'Đã xoá')
         }
      })
   }

   /**
    * Gan mot designer cho tat ca viec dang chon.
    * Viec dang "Moi" thi designer nhan thang; viec da co nguoi lam thi server tu
    * huy roi gan lai, nen o day khong can phan biet.
    */
   const handleBulkAssign = (designer: any) => {
      const items = assignableSelected
      if (items.length === 0) {
         showMessageError('Không có việc nào trong danh sách chọn có thể gán designer')
         return
      }
      const skipped = selectedRows.length - items.length
      const designerName = designer?.name || designer?.email
      const reassign = items.filter((item) => item?.designerId && item?.designerId !== designer?.id).length
      confirm({
         title: 'Gán designer',
         icon: <ExclamationCircleOutlined />,
         content: `${items.length} việc sẽ được gán cho <b>${designerName}</b>.${
            reassign > 0 ? `<br/>${reassign} việc đang có designer khác sẽ bị huỷ và gán lại.` : ''
         }${skipped > 0 ? `<br/>${skipped} việc đang chọn không gán được và sẽ bị bỏ qua.` : ''}`,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await runBulkAction(items, (id) => JobsStore.assignJobSilent(id, designer?.id), 'Đã gán designer cho')
         }
      })
   }

   /**
    * Luu nhanh mot truong cua viec ngay tren bang (url, link design, seller).
    * Sua xong chi va lai dung dong do thay vi tai lai ca trang, de khong mat vi
    * tri cuon va danh sach dang chon.
    */
   const handleSaveJobField = async (record: any, patch: any) => {
      const result = await JobsStore.updateJobInfo(record?.id, patch)
      if (!result) return false
      JobsStore.action_patchJobRow(record?.id, patch)
      showMessageSuccess('Đã cập nhật')
      return true
   }

   const columns = [
      // {
      //     title: t(GLOBAL_CLIENT.sothutu),
      //     dataIndex: "index",
      //     key: "index",
      //     align: "center" as "center",
      //     width: 80,
      //     // fixed: 'left',
      //     render: (value: string, record: any, index: number) =>
      //         (page-1) * PAGE_SIZE + index + 1,
      // },
      {
         title: t(GLOBAL_CLIENT.id),
         dataIndex: 'name',
         key: 'name',
         width: 70,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: t(GLOBAL_CLIENT.txtDateTime),
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'images',
         width: 126,
         key: 'images',
         render: (value: any) => {
            return (
               // Khung vuong 108px: anh ngang / doc deu nam gon trong o, khong lam cot phinh ra
               <Image
                  style={{ objectFit: 'contain' }}
                  width={108}
                  height={108}
                  preview={{
                     mask: null
                  }}
                  fallback="data:image/png;base64,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"
                  src={getImageUrl(value[0]?.path)}
               />
            )
         }
      },
      {
         // Goi y link dau tien cua viec, bam "Gan URL" de them vao cot URL ngay
         title: 'Gợi ý',
         dataIndex: 'firstSuggestion',
         width: 140,
         key: 'firstSuggestion',
         render: (_value: any, record: any) => {
            return <JobSuggestionCell job={record} />
         }
      },
      {
         title: t(GLOBAL_CLIENT.creator),
         dataIndex: 'creator',
         width: 80,
         key: 'creator',
         render: (value: any) => {
            return (
               <span onClick={showDetailCreator(value)} className="gx-link txtMax2Line">
                  {value?.name || value?.email}
               </span>
            )
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: t(GLOBAL_CLIENT.designer),
         dataIndex: 'designer',
         width: 80,
         key: 'designer',
         render: (value: any) => {
            return (
               <span onClick={showDetailDesigner(value)} className="gx-link txtMax2Line">
                  {value?.name || value?.email}
               </span>
            )
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: t(GLOBAL_CLIENT.seller),
         dataIndex: 'seller',
         width: 90,
         key: 'seller',
         render: (value: any) => {
            return <span className="txtMax2Line">{value || ''}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.sellerOrderId),
         dataIndex: 'sellerOrderId',
         width: 90,
         key: 'sellerOrderId',
         render: (value: any) => {
            return <span className="txtMax2Line">{value || ''}</span>
         }
      },
      {
         // Ten san pham cua don, Zenith gui kem luc tao viec
         title: 'Tên sản phẩm',
         dataIndex: 'productName',
         width: 120,
         key: 'productName',
         render: (value: any) => {
            return (
               <span className="txtMax2Line" title={value || ''}>
                  {value || ''}
               </span>
            )
         }
      },
      {
         // Gan / go hashtag ngay tren bang, bam hashtag de tim
         title: t(GLOBAL_CLIENT.hashtagTitle),
         dataIndex: 'tag',
         width: 160,
         key: 'tag',
         render: (value: any, record: any) => {
            return (
               <JobHashtags jobId={record?.id} tag={value} canEdit compact onSearchHashtag={handleSearchHashtag} />
            )
         }
      },
      
      {
         // Sua duoc ngay tren bang: bam vao bieu tuong but o cuoi o de mo o nhap
         title: t(GLOBAL_CLIENT.url),
         dataIndex: 'url',
         width: 150,
         key: 'url',
         render: (value: any, record: any) => {
            return (
               <JobLinkCell
                  value={value}
                  title={t(GLOBAL_CLIENT.url)}
                  placeholder={'Nhập URL'}
                  onSave={(url: string) => handleSaveJobField(record, { url })}
               />
            )
         }
      },
      {
         // Mo ta chi tiet (cot note): o hep chi hien 2 dong, di chuot vao de xem day du
         title: t(GLOBAL_CLIENT.mota),
         dataIndex: 'note',
         width: 160,
         key: 'note',
         render: (value: any) => {
            if (!value) return <span style={{ color: '#b0b0b0' }}>{'—'}</span>
            return (
               <Popover
                  trigger="hover"
                  placement="bottomLeft"
                  title={t(GLOBAL_CLIENT.mota)}
                  content={
                     <div
                        style={{
                           maxWidth: 420,
                           maxHeight: 320,
                           overflowY: 'auto',
                           whiteSpace: 'pre-wrap',
                           wordBreak: 'break-word'
                        }}
                     >
                        {value}
                     </div>
                  }
               >
                  <span className="txtMax2Line" style={{ whiteSpace: 'pre-line', cursor: 'pointer' }}>
                     {value}
                  </span>
               </Popover>
            )
         }
      },
      {
         // Sua ngay tren bang; luu xong server tu dong bo sang orders.note1 ben Zenith
         title: t(GLOBAL_CLIENT.note1),
         dataIndex: 'note1',
         width: 150,
         key: 'note1',
         render: (value: any, record: any) => {
            return (
               <JobNoteCell
                  value={value}
                  title={t(GLOBAL_CLIENT.note1)}
                  placeholder={t(GLOBAL_CLIENT.nhapnote1)}
                  onSave={(note1: string) => handleSaveJobField(record, { note1 })}
               />
            )
         }
      },
      {
         // Chi hien dang hyperlink; muon nhap thi vao popup chi tiet viec
         title: t(GLOBAL_CLIENT.linkDesign),
         dataIndex: 'linkDesign',
         width: 140,
         key: 'linkDesign',
         render: (value: any) => {
            return <JobLinkCell value={value} />
         }
      },
      {
         // Designer nhap trong popup chi tiet viec
         title: t(GLOBAL_CLIENT.totalStitches),
         dataIndex: 'totalStitches',
         width: 90,
         key: 'totalStitches',
         render: (value: any) => {
            // Chua nhap (null) thi hien 0
            return <span>{value ?? 0}</span>
         }
      },
      {
         title: 'Target',
         dataIndex: 'targetId',
         width: 60,
         key: 'targetId',
         render: (value: any, row: any) => {
            return (
               <Checkbox
                  defaultChecked={!isEmpty(row?.targetId) || !isEmpty(row?.targetIdSave)}
                  disabled={true}
               ></Checkbox>
            )
         }
      },
      // An cot loai thiet ke
      // {
      //    title: t(GLOBAL_CLIENT.designType),
      //    dataIndex: 'designType',
      //    width: 80,
      //    key: 'designType',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value?.name || ''}</span>
      //    }
      // },
      {
         title: t(GLOBAL_CLIENT.productType),
         dataIndex: 'productType',
         width: 80,
         key: 'productType',
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name || ''}</span>
         }
      },
      {
         title: 'SL mẫu',
         dataIndex: 'count',
         width: 60,
         key: 'count',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.txtPrice) + '(VND)',
         dataIndex: 'price',
         width: 80,
         key: 'price',
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.status),
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: any) => {
            return <span className="txtMax2Line">{getStatusText(value)}</span>
         }
      },
      {
         title: 'Việc ưu tiên',
         key: 'isPriority',
         width: 80,
         align: 'center' as 'center',
         // fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return (
               <Checkbox
                  // Gan / bo uu tien duoc o moi trang thai
                  defaultChecked={record?.isPriority}
                  onChange={(e) => onChangePriority(record, e, index)}
               >
                  {/* {t(GLOBAL_CLIENT.priority)} */}
               </Checkbox>
            )
         }
      },
      {
         title: 'Người duyệt',
         dataIndex: 'approver',
         width: 80,
         key: 'approver',
         render: (value: any, record: any) => {
            if (!value) return null
            return (
               <div>
                  <span className="txtMax2Line">{value?.name || value?.email}</span>
                  {record?.approvedAt && (
                     <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                        {moment(record.approvedAt).format(DATE_TIME_FORMAT_CLIENT_short2)}
                     </span>
                  )}
               </div>
            )
         }
      },
      {
         title: 'Action',
         key: 'action',
         width: 150,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            // Viec dang cho duyet chua co designer nen "Huy" (dua viec ve trang thai
            // "Moi" de tim designer khac) hoa ra lai DUYET nham viec. Trang thai nay
            // an nut "Huy", thay bang "Xoa" — ke ca khi SHOW_DELETE_JOB_BUTTON dang tat.
            const isPendingApproval = record?.status === STATUS_JOB.PENDING
            const showDeleteJob =
               (SHOW_DELETE_JOB_BUTTON || isPendingApproval) &&
               data_getUserInfo?.role !== ROLE.SUPPORTER &&
               data_getUserInfo?.role !== ROLE.ORDER_MANAGER
            return (
               <div className="job-action-cell">
                  {isPendingApproval && (
                     <span onClick={() => handleApproveJob(record)} className="gx-link txtMax2LineHover">
                        {'Duyệt'}
                     </span>
                  )}
                  {STATUS_JOB_FINISHABLE_BY_ADMIN.includes(record?.status) && (
                     <span onClick={() => handleApproveAndFinishJob(record)} className="gx-link txtMax2LineHover">
                        {'Hoàn thành'}
                     </span>
                  )}
                  {/* Viec cho duyet gan duoc luon: server duyet truoc roi moi giao */}
                  {(record?.status === STATUS_ACTIVITY.NEW || isPendingApproval) && (
                     <AssignJob detail={record} indexItem={index} />
                  )}
                  <span onClick={() => handleShowDetail(record)} className="gx-link txtMax2LineHover">
                     {t(GLOBAL_CLIENT.detail)}
                  </span>
                  {!isPendingApproval && (
                     <span onClick={() => handleCancelJob(record)} className="gx-link txtMax2LineHover">
                        {t(GLOBAL_CLIENT.huy)}
                     </span>
                  )}
                  {showDeleteJob && (
                     <span onClick={() => handleDeleteJob(record)} className="gx-link txtMax2LineHover">
                        {t(GLOBAL_CLIENT.delete)}
                     </span>
                  )}
               </div>
            )
         }
      }
   ]

   const tableScrollX = columns.reduce((total: number, column: any) => total + (column.width || 0), 32)

   const onChangePriority = (item: any, e: any, index: number) => {
      console.log('item: ', item, 'e', e, 'inde', index)
      // setRememberMe(e.target.checked)
      handlePriority(item, e.target.checked, index)
   }

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         {/* <Loading isLoading={isLoading} /> */}
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={8}>
                     <Input.Search
                        value={searchInput}
                        onChange={(event) => setSearchInput(event.target.value)}
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.search)}
                        allowClear
                        enterButton
                     />
                  </Col>
                  <Col xs={24} md={2}>
                     {/* <Button type="primary" className="btn-add" onClick={handleFilter}>
                        <i className="icon icon-filter icon-in-button" />
                        {t(GLOBAL_CLIENT.filter)}
                     </Button> */}
                     <Filter onSubmitFilter={onSubmitFilter} onResetFilter={onResetFilter} />
                  </Col>
                  {/* <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col> */}
                  <Col xs={24} md={14}>
                     <div className="text-right">
                        <Space>
                           <Button
                              className="btn-add"
                              icon={<DownloadOutlined />}
                              loading={isExporting}
                              onClick={handleExportExcel}
                              // .btn-add la display:flex nhung khong can giua -> icon bi day len tren
                              style={{ alignItems: 'center' }}
                           >
                              {'Export Excel'}
                           </Button>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng SL mẫu</span>
                              <span
                                 style={{ fontSize: 20, color: theme.color.primary, fontWeight: 'bolder' }}
                              >{`${formatCurrency(jobTotal?.count, true)}`}</span>
                           </Button>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng tiền</span>
                              <span style={{ fontSize: 20, color: '#89AD88', fontWeight: 'bolder' }}>{`${formatCurrency(
                                 jobTotal?.price,
                                 true
                              )} VND`}</span>
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row>
               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <div>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                     <ActiveFilterSummary filter={fieldFilter} />
                  </div>
                  <div>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_JOB.PENDING, e)}
                     >
                        {'Chờ duyệt'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.NEW, e)}
                     >
                        {'Mới'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.DOING, e)}
                     >
                        {'Đang xử lí'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REVIEW, e)}
                     >
                        {'Review'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REJECT, e)}
                     >
                        {t(GLOBAL_CLIENT.cansualai)}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.FINISH, e)}
                     >
                        {'Hoàn thành'}
                     </Checkbox>
                  </div>
               </Space>
               {/* <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {count}
               </Space> */}

               {selectedRowKeys.length > 0 && (
                  <div className="bulk-action-bar">
                     <Space wrap>
                        <span>{`Đang chọn ${selectedRowKeys.length} việc`}</span>
                        <Button
                           type="primary"
                           loading={isBulkProcessing}
                           disabled={approvableSelected.length === 0}
                           onClick={handleBulkApprove}
                        >
                           {`Duyệt (${approvableSelected.length})`}
                        </Button>
                        <Button
                           type="primary"
                           loading={isBulkProcessing}
                           disabled={finishableSelected.length === 0}
                           onClick={handleBulkFinish}
                        >
                           {`Hoàn thành (${finishableSelected.length})`}
                        </Button>
                        <Button
                           danger
                           loading={isBulkProcessing}
                           disabled={cancellableSelected.length === 0}
                           onClick={handleBulkCancel}
                        >
                           {`Huỷ (${cancellableSelected.length})`}
                        </Button>
                        <Button
                           danger
                           type="primary"
                           loading={isBulkProcessing}
                           onClick={handleBulkDelete}
                        >
                           {`Xoá (${deletableSelected.length})`}
                        </Button>
                        <BulkAssignJob
                           assignableCount={assignableSelected.length}
                           loading={isBulkProcessing}
                           onAssign={handleBulkAssign}
                        />
                        <Button type="link" disabled={isBulkProcessing} onClick={clearSelection}>
                           {'Bỏ chọn'}
                        </Button>
                     </Space>
                  </div>
               )}
               <Table
                  className="job-management-table"
                  // Rong dung bang tong cac cot (+32 cot chon) de khong bi chia them khoang trong vao moi cot
                  scroll={{ x: tableScrollX, y: height - 280 }}
                  columns={columns}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
                  rowSelection={rowSelection}
               />

               {renderPagination()}
            </Col>
         </Row>
         {itemDesigner && visibleUserDetailDesigner && (
            <DetailDesigner
               visible={visibleUserDetailDesigner}
               item={itemDesigner}
               onOk={handleEditDesigner}
               onCancel={hideDetailDesigner}
               onlyView
            />
         )}
         {itemCreator && visibleUserDetailCreator && (
            <DetailCreator
               visible={visibleUserDetailCreator}
               item={itemCreator}
               onOk={handleEditCreator}
               onCancel={hideDetailCreator}
               onlyView
            />
         )}

         {/* {item && <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />} */}
         {/* <Filter visible={visibleFilter} onOk={confirmFilter} onCancel={hideFilter} /> */}
         <EditJobDetailModal
            data={selectedItem}
            visible={isOpenEditJobDetail}
            handleOk={openEditJobModal}
            handleCancel={closeEditJobModal}
         />
         <ApproveJobModal
            open={!!approveTarget}
            title={approveTarget?.title}
            okText={approveTarget?.okText}
            description={approveTarget?.description || ''}
            loading={isBulkProcessing}
            onCancel={() => setApproveTarget(null)}
            onOk={handleConfirmApprove}
         />
      </>
   )
})

export default JobManagement
